
import React, { useState } from 'react';
import WordCard from '../WordCard/WordCard'; 

const CardsPage = ({ words }) => {
  const [studiedWordIds, setStudiedWordIds] = useState(new Set());

  const handleWordStudy = (id) => {
    setStudiedWordIds(prev => new Set(prev).add(id));
  };

  return (
    <div className="cards-page">
      <h1>Mots à étudier</h1>
      <p>Mots étudiés : {studiedWordIds.size}</p> 
      {words.length > 0 ? (
        words.map((word) => (
          <WordCard
            key={word.id}  
            word={word}     
            hideTranslationButton={false}  
            onStudy={() => handleWordStudy(word.id)}
          />
        ))
      ) : (
        <p>Aucun mot disponible</p>  
      )}
    </div>
  );
};

export default CardsPage;